import { InputAdornment, Stack, Typography } from '@mui/material';

import { ModalFormLayout } from '@/components/form/layout/ModalFormLayout';
import { User01Icon } from '@/components/icons/User01Icon';
import { useFormContext } from '@/components/react-hook-form';
import { PossibleRelationshipOwnersTypeahead } from '@/modules/household/components/PossibleRelationshipOwnersTypeahead/PossibleRelationshipOwnersTypeahead';

import { ClientReassignmentFormShape } from './ClientReassignmentModal.types';

export interface ClientReassignmentFormProps {
  excludeUserId?: string;
}

export function ClientReassignmentForm({
  excludeUserId,
}: ClientReassignmentFormProps) {
  const { control } = useFormContext<ClientReassignmentFormShape>();

  return (
    <ModalFormLayout>
      <Stack spacing={1}>
        <Typography variant="body-s">
          You must reassign the clients to a new relationship manager before
          proceeding.
        </Typography>

        <PossibleRelationshipOwnersTypeahead<ClientReassignmentFormShape>
          control={control}
          fieldName="reassignedTo"
          label="Select a user to reassign as relationship manager"
          hideLabel
          placeholder="Select a user to reassign as relationship manager"
          required
          excludeUserId={excludeUserId}
          startAdornment={
            <InputAdornment position="start">
              <User01Icon size={16} />
            </InputAdornment>
          }
        />
      </Stack>
    </ModalFormLayout>
  );
}
